import { adminApi } from "@/api/client";

/** 高危写操作：`POST /admin/v1/auth/mfa/challenge` → 请求头 `X-MFA-Ticket` */
export async function requestMfaTicket(totpCode: string): Promise<string> {
  const { data, response } = await adminApi.POST(
    "/admin/v1/auth/mfa/challenge",
    { body: { totp_code: totpCode } }
  );
  if (data?.mfa_ticket) return data.mfa_ticket;
  throw new Error(`MFA challenge failed (${response.status})`);
}
